import type { InjectionKey } from 'vue'
import { inject, provide } from 'vue'

import type { ImageUtils } from './types.ts'

export const injectImageUtilsKey: InjectionKey<ImageUtils> = Symbol('image-utils')

export function useInjectImageUtils(): ImageUtils | null {
  return inject(injectImageUtilsKey) ?? null
}

export function useProvideImageUtils(fns: ImageUtils): void {
  provide(injectImageUtilsKey, fns)
}
